module.exports = __webpack_public_path__ + "img/like.63580852.svg";